// 记录滚动条位置，在页面再次打开的时候恢复滚动条位置(只针对于缓存组件)
// 注意使用这个mixin的时候需要注册一个 refs 为 scrollBar。或者通过 customWatchRef 传递 ref 自定义ref。如果未设置则默认使用当前组件实例的 $el
export default {
  data () {
    return {
      // 当前绑定的元素滚动条位置
      SCROLLBAR: 0,
      CUSTOMREF: null
    }
  },
  methods: {
    /**
     * 自定义监听ref的滚动条
     * @param {HTMLElement} ref 需要监听的dom
     * */
    customWatchRef (ref) {
      if (!ref || !(ref instanceof HTMLElement)) console.error(`${ref} is not HTMLElement`)
      this.CUSTOMREF = ref
      this.cancelWatchRef()
      this.watchRef(ref)
    },
    /**
     * 监听ref
     * @param {HTMLElement} ref 需要监听的dom
     * */
    watchRef (ref = this.getScrollBarRef) {
      const self = this
      ref.handler = ({ target }) => { self.SCROLLBAR = target.scrollTop }
      ref.addEventListener('scroll', ref.handler, true)
    },
    /**
     * 取消监听
     * */
    cancelWatchRef () {
      const ref = this.getScrollBarRef
      ref.removeEventListener('scroll', ref.handler, true)
    }
  },
  mounted () {
    this.watchRef()
  },
  activated () {
    // 在激活的时候重新给设置的ref赋值
    this.$nextTick(() => { this.getScrollBarRef.scrollTop = this.SCROLLBAR })
  },
  computed: {
    getScrollBarRef () {
      return this.$refs.scrollBar || this.CUSTOMREF || this.$el
    }
  },
  beforeDestroy () {
    this.cancelWatchRef()
  }
}



// WEBPACK FOOTER //
// ./src/plugins/scrollBar/index.js